.figure {
  margin: 0;
}
/* Twelve columns by eight rows of square tiles. */
.grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  grid-template-rows: repeat(8, auto);
  gap: clamp(3px, 0.45vw, 6px);
}
.tile {
  display: grid;
  place-items: center;
  aspect-ratio: 1;
  border: 1px solid var(--border);
  border-radius: clamp(3px, 0.4vw, 6px);
  background: var(--surface-raised);
  color: var(--text-muted);
  font-size: clamp(0.5625rem, 0.3vw + 0.45rem, 0.8125rem);
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: default;
}
/* The state's DOT is a client: the one fact the map exists to show. */
.dot {
  border-color: var(--accent);
  background: var(--accent);
  color: #0b0e12;
}
/* Other clients in the state (a city, an agency): outlined in the same colour. */
.other {
  border-color: var(--accent);
  background: color-mix(in srgb, var(--accent) 14%, var(--surface-raised));
  color: var(--text-strong);
}
.legend {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2) var(--sp-6);
  margin-top: var(--sp-5);
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
.key {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
}
.swatch {
  width: 0.9rem;
  height: 0.9rem;
  border: 1px solid var(--accent);
  border-radius: 3px;
}
